import React from 'react';
import { connect } from 'react-redux';
import { showProcedureManual, hideProcedureManual, updateSDN, createProcedureManual } from '../../reduxActions/ProcedureManualActions';

const ProceduresManualContext = React.createContext({});

class ProceduresManualStore extends React.Component {
    state = {
        sdnFormValue: "",
        sdnRevFormValue: "",
        sdnCommentFormValue: "",
        sortProperty: 'title',
        sortReverse: true,
        deviationAction: null
    };

    componentDidMount() {

    }

    setSortProperty = sortProperty => {
        const sortReverse = sortProperty === this.state.sortProperty ? !this.state.sortReverse : this.state.sortProperty;
        this.setState({ sortProperty, sortReverse });
    }

    updateSdnFormValue = sdnFormValue => this.setState({ sdnFormValue });
    updateSdnRevFormValue = sdnRevFormValue => this.setState({ sdnRevFormValue });
    updateSdnCommentFormValue = sdnCommentFormValue => this.setState({ sdnCommentFormValue });
    displayDeviationReasoning = deviationAction => this.setState({ deviationAction });

    render() {

        return (

            <ProceduresManualContext.Provider
                value={
                    {
                        ...this.state,
                        ...this.props,
                        updateSdnFormValue: this.updateSdnFormValue,
                        updateSdnRevFormValue: this.updateSdnRevFormValue,
                        updateSdnCommentFormValue: this.updateSdnCommentFormValue,
                        setSortProperty: this.setSortProperty,
                        displayDeviationReasoning: this.displayDeviationReasoning
                    }
                }>
                {this.props.children}
            </ProceduresManualContext.Provider>

        );
    }
}

const mapStateToProps = state => {
    const { procedureManual } = state;
    return { procedureManual, contentHeight: state.app.contentSize.height };
}

ProceduresManualStore = connect(mapStateToProps, { showProcedureManual, hideProcedureManual, updateSDN, createProcedureManual })(ProceduresManualStore);

export { ProceduresManualStore };

export default ProceduresManualContext;